<template>
  <div class="container">
    <section class="section is-light">
      <div class="has-text-centered">
        <img style="height: 200px" src="../assets/contact.svg" alt="Home" />
        <p class="title">Contact Us</p>
        <p class="subtitle">
          Call or flick us an email! We are always ready to help you
        </p>

        <div :key="row" v-for="row in Array(numRows).keys()" class="columns">
          <div
            :class="['contact-' + col]"
            class="column contact"
            v-for="col in Array(numContactsPerRow).keys()"
            :key="col"
          >
            <div v-if="contacts[numContactsPerRow * row + col]">
              <p>{{ contacts[numContactsPerRow * row + col].name }}</p>
              <p>{{ contacts[numContactsPerRow * row + col].email }}</p>
              <p>{{ contacts[numContactsPerRow * row + col].phone }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import ScrollReveal from "scrollreveal";
export default {
  name: "Contacts",
  components: {},
  computed: {
    numRows() {
      return Math.ceil(this.contacts.length / 4);
    },
  },
  data: function () {
    return {
      numContactsPerRow: 4,
      contacts: [
        {
          name: "Rudy",
          email: "rudy@zies.net",
          phone: "+62 812-8777-3794",
        },
        {
          name: "Mariani T.",
          email: "mariani.t@zies.net",
          phone: "+62 812-9815-2301",
        },
        {
          name: "Hadely T.",
          email: "hadely@zies.net",
          phone: "+62 81-678-5695",
        },
        {
          name: "Mina",
          email: "mina@zies.net",
          phone: "+62 82-161-078-687",
        },
      ],
    };
  },
  mounted() {
    const defaultDelay = 300;
    const slideRight = {
      distance: "105%",
      origin: "left",
      duration: 2000,
      delay: defaultDelay,
      mobile: false,
    };
    const sr = ScrollReveal(slideRight);

    sr.reveal(".contact-0", slideRight);
    sr.reveal(".contact-1", { delay: 3 * defaultDelay });
    sr.reveal(".contact-2", { delay: 5 * defaultDelay });
    sr.reveal(".contact-3", { delay: 7 * defaultDelay });
  },
  methods: {},
};
</script>

<style scoped>
.multiline {
  white-space: pre-wrap;
}

.contact {
  margin-top: 3rem;
}
</style>
